import IconChevronRight from "@src/assets/icons/lucide/chevron-right.svg?react";
import { LoadingSpinner } from "@src/components/loading-spinner";

interface ReferralInviteHistorySectionProps {
	validReferrals: number;
	isPending: boolean;
	onOpenInviteHistory: () => void;
}

function ReferralCountLoader() {
	return (
		<div className="flex items-center justify-center w-8 h-8">
			<LoadingSpinner
				width={24}
				height={24}
				style={{ color: "var(--ui-color-text-muted)" }}
			/>
		</div>
	);
}

export function ReferralInviteHistorySection({
	validReferrals,
	isPending,
	onOpenInviteHistory,
}: ReferralInviteHistorySectionProps) {
	return (
		<div className="flex flex-col gap-4">
			<div>
				<p className="mb-1 uppercase tracking-wider text-text-muted text-xs font-bold">
					Invitation History
				</p>
				<p className="sm:text-sm text-text-secondary text-xs">
					Track how many friends have joined through your referral.
				</p>
			</div>

			<button
				type="button"
				onClick={onOpenInviteHistory}
				title="View invitation history"
				aria-label="View invitation history"
				className="flex items-center justify-between p-4 bg-surface-subtle border border-border-default rounded-xl hover:bg-surface-hover-subtle transition-colors cursor-pointer group"
			>
				<div className="flex flex-col gap-0.5 items-start">
					<span className="text-2xl font-bold text-text-primary">
						{isPending ? <ReferralCountLoader /> : validReferrals}
					</span>
					<span className="text-xs text-text-secondary font-medium">
						Valid Referrals
					</span>
				</div>
				<IconChevronRight className="w-5 h-5 text-text-muted group-hover:text-text-secondary transition-colors" />
			</button>
		</div>
	);
}
